import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import { eq } from 'ember-truth-helpers';
import ChangesetLabeledInput, {
  type S as ChangesetLabeledInputSig
} from './labeled-input.ts';

interface Signature {
  Element: ChangesetLabeledInputSig['Element'];
  Args: Pick<
    ChangesetLabeledInputSig['Args'],
    | 'propertyName'
    | 'labelName'
    | 'changeset'
    | 'isReadOnly'
    | 'disabled'
    | 'min'
    | 'max'
    | 'placeholder'
    | 'isMandatory'
    | 'value'
    | 'moreInformation'
  > & {
    castToNumber?: boolean;
    type?: string;
  };
}

export default class NumberInputComponent extends Component<Signature> {
  onChangesetUpdate = (changeset: EmberChangeset) => {
    if (this.args.castToNumber) {
      changeset.set(
        this.args.propertyName,
        Number(changeset.get(this.args.propertyName))
      );
    }
  };

  <template>
    <ChangesetLabeledInput
      @labelName={{@labelName}}
      @changeset={{@changeset}}
      @propertyName={{@propertyName}}
      @type='number'
      @isReadOnly={{@isReadOnly}}
      @disabled={{@disabled}}
      @step={{if (eq @type 'integer') '1' 'any'}}
      @pattern={{if (eq @type 'integer') '[0-9]+' '[0-9]+([\.,][0-9]+)?'}}
      @autocomplete='off'
      @min={{@min}}
      @max={{@max}}
      @placeholder={{@placeholder}}
      @isMandatory={{@isMandatory}}
      @onChangesetUpdate={{this.onChangesetUpdate}}
      @value={{@value}}
      @moreInformation={{@moreInformation}}
      ...attributes
    />
  </template>
}
